// Shopify Cart Lochung Validation Script
// Version: Basis - Nur Warnung
// Zweck: Warnt wenn Lochungs-Mengen nicht übereinstimmen

(function() {
  'use strict';
  
  console.log('🚀 Cart Lochung Validation Script gestartet');
  
  // Bekannte Lochungs-Variant-IDs
  const lochungVariantIds = [
    '50371640787210', // IVZ-Norm Standardplan I
    '50371640819978', // IVZ-Norm Standardplan II  
    '50371640852746'  // IVZ-Norm Standardplan III
  ];
  
  // Aktuellen Warenkorb abrufen
  async function getCurrentCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      return await response.json();
    } catch (error) {
      console.error('❌ Fehler beim Abrufen des Warenkorbs:', error);
      return null;
    }
  }
  
  // Warenkorb auf Lochung validieren
  async function validateCartLochung() {
    console.log('🔍 Validiere Warenkorb...');
    
    const cart = await getCurrentCart();
    if (!cart || !cart.items || cart.items.length === 0) {
      console.log('🛒 Warenkorb ist leer oder nicht verfügbar');
      return true;
    }
    
    let hauptprodukteMenge = 0;
    let lochungsMenge = 0;
    const hauptprodukte = [];
    const lochungsprodukte = [];
    
    // Analysiere alle Warenkorb-Items
    cart.items.forEach(item => {
      const isLochung = lochungVariantIds.includes(item.variant_id.toString());
      
      console.log('🔍 Analysiere Item:', {
        title: item.product_title,
        variant_id: item.variant_id,
        variant_title: item.variant_title,
        properties: item.properties,
        isLochung: isLochung
      });
      
      if (isLochung) {
        lochungsMenge += item.quantity;
        lochungsprodukte.push({
          id: item.variant_id,
          title: item.product_title,
          quantity: item.quantity
        });
        console.log('➕ Lochungsprodukt gefunden:', item.product_title);
      } else {
        // Prüfe ob Hauptprodukt eine Lochung benötigt
        let needsLochung = false;
        let hasKeineLochung = false;
        
        if (item.properties) {
          for (const [key, value] of Object.entries(item.properties)) {
            if (key.toLowerCase().includes('lochung')) {
              const lochungValue = value?.toString() || '';
              console.log('🔍 Lochung Property:', key, '=', lochungValue);
              
              // Prüfe zuerst ob explizit "Keine Lochung" gewählt wurde
              if (lochungValue && 
                  (lochungValue.toLowerCase().includes('keine lochung') || 
                   lochungValue.toLowerCase().includes('keine'))) {
                hasKeineLochung = true;
                console.log('❌ Keine Lochung gewählt:', lochungValue);
                break;
              }
              
              // Prüfe ob es eine echte Lochung ist
              if (lochungValue && 
                  (lochungValue.toLowerCase().includes('lochung nach') ||
                   lochungValue.toLowerCase().includes('ivz') ||
                   lochungValue.toLowerCase().includes('standardplan'))) {
                needsLochung = true;
                console.log('✅ Echte Lochung benötigt:', lochungValue);
                break;
              }
            }
          }
        }
        
        // Nur wenn NICHT explizit "Keine Lochung" gewählt wurde, prüfe Flachform
        if (!hasKeineLochung && item.variant_title?.includes('Flachform')) {
          needsLochung = true;
          console.log('✅ Flachform erkannt - braucht Lochung');
        }
          
        if (needsLochung) {
          hauptprodukteMenge += item.quantity;
          hauptprodukte.push({
            id: item.variant_id,
            title: item.product_title,
            quantity: item.quantity
          });
          console.log('➕ Hauptprodukt mit Lochung gefunden:', item.product_title);
        } else {
          console.log('➖ Hauptprodukt ohne Lochung:', item.product_title);
        }
      }
    });
    
    console.log('📊 Mengen-Analyse:', {
      hauptprodukteMenge,
      lochungsMenge,
      hauptprodukte: hauptprodukte,
      lochungsprodukte: lochungsprodukte
    });
    
    // Validierung
    const isValid = hauptprodukteMenge === lochungsMenge;
    
    if (isValid) {
      console.log('✅ Lochungs-Validierung erfolgreich');
      // Entferne alte Warnungen bei korrektem Zustand
      const oldWarning = document.querySelector('.lochung-warning');
      if (oldWarning) oldWarning.remove();
      return true;
    } else {
      console.warn('⚠️ WARNUNG: Lochungs-Mengen stimmen nicht überein!');
      console.warn(`Hauptprodukte mit Lochung: ${hauptprodukteMenge}`);
      console.warn(`Lochungsprodukte: ${lochungsMenge}`);
      
      // Zeige Warnung an
      showLochungWarning(hauptprodukteMenge, lochungsMenge);
      
      return false;
    }
  }
  
  // Warnung anzeigen
  function showLochungWarning(sollMenge, istMenge) {
    // Entferne alte Warnungen
    const oldWarning = document.querySelector('.lochung-warning');
    if (oldWarning) oldWarning.remove();
    
    console.log('🚨 Zeige Lochungs-Warnung an');
    
    // Erstelle neue Warnung
    const warning = document.createElement('div');
    warning.className = 'lochung-warning';
    warning.style.cssText = `
      background: #fff3cd !important;
      border: 1px solid #ffeaa7 !important;
      color: #856404 !important;
      padding: 15px !important;
      margin: 10px 0 !important;
      border-radius: 5px !important;
      font-weight: bold !important;
      position: relative !important;
      z-index: 9999 !important;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    `;
    
    // Erstelle benutzerfreundlichen Text
    let warningText = '';
    let actionButtons = '';
    
    if (sollMenge > istMenge) {
      const fehlendeLochungen = sollMenge - istMenge;
      
      if (fehlendeLochungen === 1) {
        warningText = `⚠️ <strong>Achtung:</strong> Sie haben ${sollMenge} Verkehrsschild${sollMenge > 1 ? 'er' : ''} mit Lochung im Warenkorb, aber nur ${istMenge} Lochung${istMenge !== 1 ? 'en' : ''}.<br>
        <strong>Bitte fügen Sie noch ${fehlendeLochungen} Lochung zu Ihrem Warenkorb hinzu.</strong>`;
      } else {
        warningText = `⚠️ <strong>Achtung:</strong> Sie haben ${sollMenge} Verkehrsschilder mit Lochung im Warenkorb, aber nur ${istMenge} Lochung${istMenge !== 1 ? 'en' : ''}.<br>
        <strong>Bitte fügen Sie noch ${fehlendeLochungen} Lochungen zu Ihrem Warenkorb hinzu.</strong>`;
      }
      
      // Action Buttons für fehlende Lochungen
      actionButtons = `
        <div style="margin-top: 10px; display: flex; gap: 10px; align-items: center;">
          <button onclick="addLochungToCart(${fehlendeLochungen})" 
                  style="background: #28a745; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: bold;">
            🛒 ${fehlendeLochungen} Lochung${fehlendeLochungen !== 1 ? 'en' : ''} hinzufügen
          </button>
          <span style="margin: 0 5px;">oder</span>
          <a href="https://menne-verkehrstechnik.de/products/option-set-829061-select-1?variant=50371640787210" 
             target="_blank" 
             style="color: #856404; text-decoration: underline; font-weight: bold;">
            📋 Lochungsprodukt ansehen
          </a>
        </div>
      `;
    } else if (sollMenge < istMenge) {
      const zuVieleLochungen = istMenge - sollMenge;
      warningText = `⚠️ <strong>Achtung:</strong> Sie haben ${istMenge} Lochung${istMenge !== 1 ? 'en' : ''} im Warenkorb, aber nur ${sollMenge} Verkehrsschild${sollMenge !== 1 ? 'er' : ''} mit Lochung.<br>
      <strong>Bitte entfernen Sie ${zuVieleLochungen} Lochung${zuVieleLochungen !== 1 ? 'en' : ''} aus Ihrem Warenkorb.</strong>`;
    }
    
    warning.innerHTML = `
      ${warningText}
      ${actionButtons}
      <button onclick="this.parentElement.remove()" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 18px; cursor: pointer; color: #856404;" title="Warnung schließen">×</button>
    `;
    
    // Versuche verschiedene Einfügepunkte
    const insertTargets = [
      '.cart-form',
      '.cart',
      '.cart-drawer',
      '.mini-cart', 
      '[class*="cart"]',
      '.cart-items',
      '.cart-content',
      'main',
      'body'
    ];
    
    let inserted = false;
    for (const selector of insertTargets) {
      const target = document.querySelector(selector);
      if (target) {
        console.log('📍 Füge Warnung ein bei:', selector);
        target.insertBefore(warning, target.firstChild);
        inserted = true;
        break;
      }
    }
    
    if (!inserted) {
      console.warn('⚠️ Konnte Warnung nicht einfügen - füge zu body hinzu');
      document.body.insertBefore(warning, document.body.firstChild);
    }
    
    // Auto-Remove nach 15 Sekunden (länger wegen Buttons)
    setTimeout(() => {
      if (warning.parentNode) {
        warning.remove();
        console.log('🗑️ Warnung automatisch entfernt');
      }
    }, 15000);
  }
  
  // Globale Funktion um Lochung zum Warenkorb hinzuzufügen
  window.addLochungToCart = async function(quantity = 1) {
    try {
      console.log(`🛒 Füge ${quantity} Lochung(en) zum Warenkorb hinzu...`);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: '50371640787210', // Standard-Lochung Plan I
          quantity: quantity
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('✅ Lochung erfolgreich hinzugefügt:', result);
        
        // Entferne Warnung
        const warning = document.querySelector('.lochung-warning');
        if (warning) warning.remove();
        
        // Zeige Erfolgs-Nachricht
        showSuccessMessage(quantity);
        
        // Trigger Cart Updates
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        if (typeof window.theme !== 'undefined' && window.theme.cart) {
          window.theme.cart.getCart();
        }
        
        // Warenkorb neu validieren
        setTimeout(validateCartLochung, 500);
        
      } else {
        const error = await response.text();
        console.error('❌ Fehler beim Hinzufügen der Lochung:', error);
        alert('Fehler beim Hinzufügen der Lochung. Bitte versuchen Sie es erneut.');
      }
      
    } catch (error) {
      console.error('❌ Fehler bei addLochungToCart:', error);
      alert('Fehler beim Hinzufügen der Lochung. Bitte versuchen Sie es erneut.');
    }
  };
  
  // Erfolgs-Nachricht nach erfolgreichem Hinzufügen
  function showSuccessMessage(quantity) {
    const successMessage = document.createElement('div');
    successMessage.className = 'lochung-success';
    successMessage.style.cssText = `
      background: #d4edda !important;
      border: 1px solid #c3e6cb !important;
      color: #155724 !important;
      padding: 15px !important;
      margin: 10px 0 !important;
      border-radius: 5px !important;
      font-weight: bold !important;
      position: relative !important;
      z-index: 9999 !important;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    `;
    
    successMessage.innerHTML = `
      ✅ <strong>Perfekt!</strong> ${quantity} Lochung${quantity !== 1 ? 'en' : ''} wurde${quantity !== 1 ? 'n' : ''} zu Ihrem Warenkorb hinzugefügt.
      <button onclick="this.parentElement.remove()" style="float: right; background: none; border: none; font-size: 18px; cursor: pointer; color: #155724; margin-left: 10px;" title="Nachricht schließen">×</button>
    `;
    
    // Füge zur gleichen Stelle ein wie Warnung
    const insertTargets = [
      '.cart-form',
      '.cart',
      '.cart-drawer',
      '.mini-cart', 
      '[class*="cart"]',
      'main',
      'body'
    ];
    
    for (const selector of insertTargets) {
      const target = document.querySelector(selector);
      if (target) {
        target.insertBefore(successMessage, target.firstChild);
        break;
      }
    }
    
    // Auto-Remove nach 5 Sekunden
    setTimeout(() => {
      if (successMessage.parentNode) {
        successMessage.remove();
      }
    }, 5000);
  }
  
  // Event-Listener für Warenkorb-Änderungen
  function initCartValidation() {
    // Bei Warenkorb-Updates validieren
    document.addEventListener('cart:updated', () => {
      console.log('🔄 Cart updated event - validiere...');
      setTimeout(validateCartLochung, 500);
    });
    
    // Bei Seiten-Load validieren (für Warenkorb-Seite)
    if (window.location.pathname.includes('/cart')) {
      console.log('🛒 Warenkorb-Seite erkannt - validiere...');
      setTimeout(validateCartLochung, 1000);
    }
    
    // Bei Quantity-Änderungen validieren
    document.addEventListener('change', (e) => {
      if (e.target.name === 'updates[]' || e.target.classList.contains('cart-quantity')) {
        console.log('📊 Quantity geändert - validiere...');
        setTimeout(validateCartLochung, 500);
      }
    });
    
    // Bei Klicks auf Entfernen-Buttons
    document.addEventListener('click', (e) => {
      if (e.target.matches('a[href*="/cart/change"]') || 
          e.target.matches('[data-cart-remove]') ||
          e.target.closest('[data-cart-remove]') ||
          e.target.matches('.cart-remove') ||
          e.target.closest('.cart-remove')) {
        console.log('🗑️ Entfernen-Button geklickt - validiere in 1s...');
        setTimeout(validateCartLochung, 1000);
      }
    });
    
    // Periodische Validierung alle 3 Sekunden (für Drawer-Updates)
    setInterval(() => {
      if (window.location.pathname.includes('/cart') || 
          document.querySelector('.cart-drawer, .mini-cart, [class*="cart"]')) {
        validateCartLochung();
      }
    }, 3000);
  }
  
  // Script initialisieren
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartValidation);
  } else {
    initCartValidation();
  }
  
  // Globale Funktion für manuelles Testen
  window.validateLochung = validateCartLochung;
  
})();